import React from 'react';
import { Navigate } from 'react-router-dom';
import Auth from '../utils/auth';

const PrivateRoute = ({ children }) => {
  const isLogin = !!Auth.get("userId");

  return isLogin ? children : <Navigate to="/Login" />;
};

export default PrivateRoute;
